import { TopSellingAreaType } from "@/types/dashboard/topSellingArea";

export interface TopSellingAreaInterface {
  list: Array<TopSellingAreaType>;
  toChartDate(): Array<any>;
}

class TopSellingArea implements TopSellingAreaInterface {
  list: Array<TopSellingAreaType> = [];

  constructor(data?: Array<TopSellingAreaType>) {
    if (data) {
      this.list = data;
    }
  }

  toChartDate(): Array<any> {
    return this.list;
  }
}

export default TopSellingArea;
